const mixpanelEvents = {
  settingsAppearance: 'settings_appearance',
};

export default mixpanelEvents;
